import { Box, IconButton, Typography } from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import dayjs from "dayjs";

import { useRequestNotificationPermission } from "./index";

export const GetNotificationPermission = () => {
  const { permission, isNotificationAvailable, requestPermission, rejectPermission, getPersistedNotificationValue } =
    useRequestNotificationPermission();

  return (
    <>
      {isNotificationAvailable() && (
        <>
          {(getPersistedNotificationValue() ? dayjs().isAfter(dayjs(getPersistedNotificationValue())) : true) &&
          permission === "default" ? (
            <Box
              position="fixed"
              bottom={0}
              left={0}
              width="100vw"
              height="65px"
              display="flex"
              alignItems="center"
              justifyContent="center"
              style={{ backgroundColor: "#4f4f4f", zIndex: 5000, color: "white" }}
            >
              <Box mx={2}>
                <Typography>Show desktop notifications?</Typography>
              </Box>
              <IconButton onClick={requestPermission}>
                <CheckIcon style={{ color: "white" }} />
              </IconButton>
              <IconButton onClick={rejectPermission}>
                <CloseIcon style={{ color: "white" }} />
              </IconButton>
            </Box>
          ) : null}
        </>
      )}
    </>
  );
};
